import { ClassNameProps, makeClassName, StyleProps } from "@hex-insights/core";
import { Newsletter, User, UserNameAndImageFragment } from "../../../../Utilities";
import { NewsletterFormat } from "../../../Format";
import {
	AuthorTimestampView as GeneralAuthorTimestampView,
	AuthorTimestampViewProps as GeneralAuthorTimestampViewProps,
} from "../../_General/Author";
import styles from "./styles.module.css";

export type AuthorTimestampViewProps = {
	newsletter: Pick<Newsletter, "releaseAt"> & {
		author: (Pick<User, "id"> & UserNameAndImageFragment) | null;
	};
} & Pick<GeneralAuthorTimestampViewProps, "timestampVariant"> &
	Partial<ClassNameProps & StyleProps>;

export function AuthorTimestampView({
	newsletter,
	timestampVariant = "absolute",
	className,
	style,
}: AuthorTimestampViewProps) {
	return (
		<GeneralAuthorTimestampView
			author={newsletter.author}
			timestamp={newsletter.releaseAt}
			timestampVariant={timestampVariant}
			timestampContent={
				timestampVariant === "absolute" ? NewsletterFormat.Fields.releaseAt(newsletter.releaseAt) : undefined
			}
			timestampFallback={
				<span className={styles["newsletter-modal__timestamp--fallback"]}>
					{NewsletterFormat.Fields.releaseAt(newsletter.releaseAt)}
				</span>
			}
			timestampClassName={styles["newsletter-modal__timestamp"]}
			className={makeClassName(styles["newsletter-author-timestamp-view"], className)}
			style={style}
		/>
	);
}
